import React, { lazy, FC, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import ProtectedRouteProvider from "./context/ProtectedRouteProvider";
import ChooseBrand from "./pages/ChooseBrand";
import i18n from "./i18n/i18n";

const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const CreateAccount = lazy(() => import("./pages/CreateAccount"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const TailoringDress = lazy(() => import("./pages/TailoringDress"));

const App: FC = () => {
  console.log("====>CHANGED MADE ON 3 JUNE");
  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    } else {
      i18n.changeLanguage("en");
    }
  }, []);

  return (
    <Router>
      <AccessibleNavigationAnnouncer />
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/create-account" component={CreateAccount} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <ProtectedRouteProvider>
          <Route path="/choose-brand" component={ChooseBrand} />
          <Route path="/app" component={Layout} />
        </ProtectedRouteProvider>
        <Redirect exact from="/" to="/login" />
      </Switch>
    </Router>
  );
};

export default App;
